import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "../common/CustomModal.css";

const SendRequestModal = ({ show, handleClose, handleConfirm, product }) => {
 
  return (
    <Modal className="custom-modal" centered show={show} onHide={handleClose}>
      <Modal.Body>
        
        <p className="light-title  text-left mb-3">
          Some of the details are missing, please complete all missing details
          to send request.
        </p>
        <ul className="mt-2">
        {product?.productName == "" && 
        <li className="title text-left">
          Please enter product name
        </li>}
        {!product?.images || product.images.length==0 && 
        <li className="title text-left">
          Please add image
        </li>}
        {!product?.description || product?.description == "" ? 
        <li className="title text-left">
          Please add long description
        </li>:""}
        {product?.metaInformation?.keywords.length == 0 && 
        <li className="title text-left">
          Please add keywords
        </li>}
        {product?.manufacturer == "" && 
        <li className="title text-left">
          Please add Brand
        </li>}
        {(product?.price == null || product?.price =="") && 
        <li className="title text-left">
          Please add transfer price
        </li>}
        {(product?.taxClass == "" || product?.taxClass == null) && 
        <li className="title text-left">
          Please add GST
        </li>}
        {(product?.originCountry == "" || product?.originCountry == null) && 
        <li className="title text-left">
          Please add country of origin
        </li>}
        {/* {!product?.HSN && 
        <li className="title text-left">
          Please add HSN
        </li>} */}
        {/* {!product?.pkgs || product.pkgs.length==0 && 
        <li className="title text-left">
          Please add packages
        </li>} */}
        {!product?.stock && 
        <li className="title text-left">
          Please add stock count
        </li>} 
        </ul>
        <div className="action-buttons">
         
          <Button
            className="no-button"
            variant="secondary flex-center"
            onClick={handleClose}
          >
            Not Now
          </Button>
          <NavLink target={'_blank'} onClick={handleClose} to={"/form/" + product._id}>
            <Button variant="primary" className="yes-button orange-border flex-center">
              Add Details
            </Button>
          </NavLink>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SendRequestModal;
